<template>
  <div class="table-documents">

    <div class="heading" v-if="title || desc">
      <div class="title" v-if="title">
        {{ title }}
      </div>
      <div class="desc" v-if="desc">
        {{ desc }}
      </div>
    </div>

    <div class="the-table" v-if="files.length > 0">
      <div class="headers">
        <div 
          class="row"
          :class="[
            includeProjects ? 'include-projects' : ''
          ]"
          >
          <span>File</span>
          <span v-if="includeProjects">Case</span>
          <span>Size</span>
          <span>Status</span>
          <span>Options</span>
        </div>
      </div>
      <div class="table">
        <template 
          v-for="(file, index) in files"
          :key="index">
          <div 
            v-if="(file.is_available || showProcessing) && includeProjects"
            class="outer"
            >
            <div class="row include-projects">
              <span>{{ file.file_name }}</span>
              <span>{{ file.projectHash }}</span>
              <span>{{ humanFileSize(file.size) }}</span>
              <span
                :class="[
                  file.is_available ? 'available' : 'processing'
                ]"
                >
                {{ file.is_available ? 'Available' : 'Processing' }}
              </span>
              <span>
                <i 
                  class="fal fa-trash-alt"
                  v-if="['admin', 'team_admin'].includes($page.props.user.user_type) && canDelete && file.is_available"
                  @click="deleteFile(file.id)"
                  />
                <a :href="`/download/${base64Encode(file.id)}`" v-if="file.is_available && canDownload" target="_blank" class="link">
                  <i class="fal fa-download"></i>
                </a>
              </span>
            </div>
          </div>
          <div 
            v-if="(file.is_available || showProcessing) && !includeProjects"
            class="outer"
            >
            <div class="row">
              <span>
                {{ file.nice_name ? file.nice_name : file.file_name }}
                <div class="active-marker" v-if="topIsActive && index == 0">Active</div>
              </span>
              <span>{{ humanFileSize(file.size) }}</span>
              <span
                :class="[
                  file.is_available ? 'available' : 'processing'
                ]"
                >
                {{ file.is_available ? 'Available' : 'Processing' }}
              </span>
              <span>
                <i 
                  class="fal fa-trash-alt"
                  v-if="['admin', 'team_admin'].includes($page.props.user.user_type) && canDelete && file.is_available"
                  @click="deleteFile(file.id)"
                  />
                <a :href="`/download/${base64Encode(file.id)}`" v-if="file.is_available && canDownload" target="_blank" class="link">
                  <i class="fal fa-download"></i>
                </a>
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <Placeholder
      v-else
      :message="noDocsMessage"
      />

  </div>
</template>

<script>

import Placeholder from "@/Components/Placeholder"

export default {
  components: {
    Placeholder
  },
  props: {
    title: String,
    desc: String,
    files: Object,
    noDocsMessage: {
      type: String,
      default: 'You have no documents'
    },
    includeProjects: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    showProcessing: {
      type: Boolean,
      default: true
    },
    topIsActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    humanFileSize(payload) {
      let fileSize = ''
      let size = parseInt(payload)

      if (size >= 1073741824) {
        fileSize = this.round(size / 1024 / 1024 / 1024, 1) + ' GB'
      } else if (size >= 1048576) {
        fileSize = this.round(size / 1024 / 1024, 1) + ' MB'
      } else if(size >= 1024) {
        fileSize = this.round(size / 1024, 1) + ' KB'
      } else {
        fileSize = size + ' bytes'
      }
      return fileSize
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    base64Encode(string){
      let value = String(string)
      if (process.client) {
        return window.btoa(unescape(encodeURIComponent(value)))
      } else {
        return Buffer.from(value, 'ascii').toString('base64')
      }
    },
    deleteFile(id){
      if(confirm('Are you sure you wish to delete this file? This action cannot be undone!')){
        this.$inertia.post(`/delete-file/${id}`)
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.table-documents
  width: 100%
  display: flex
  flex-direction: column
  margin-bottom: 50px

  .heading
    width: 100%
    margin-bottom: 30px

    .title
      font-size: 24px
      font-weight: 700
      font-family: 'Roboto Condensed', sans-serif
      color: #252525
      line-height: 1.1
      margin-bottom: 8px

    .desc
      font-size: 16px
      font-weight: 400
      font-family: 'Roboto', sans-serif
      color: #6a6a6a
      line-height: 1.1

  .the-table
    .row
      display: grid
      grid-template-columns: 1fr 0.3fr 0.3fr 0.3fr

      &.include-projects
        grid-template-columns: 1.5fr 0.5fr 0.3fr 0.3fr 0.3fr

      span
        display: flex
        align-items: center

        &:last-child
          justify-content: flex-end

        &.available
          color: #00a000

        &.processing
          color: #d00

    @media (max-width: 900px)
      overflow-x: auto
      
      .row
        display: flex

        span
          min-width: 190px

    .headers
      font-size: 18px
      font-weight: 700
      font-family: 'Roboto Condensed', sans-serif
      color: #252525
      line-height: 1.1
      margin-bottom: 10px

      .row
        padding: 0 20px

    .table
      width: 100%
      background-color: #fff
      border-radius: 8px
      box-shadow: 0 1px 3px rgba(#000, 0.12)
      padding: 0 20px

      .outer
        border-bottom: 1px solid #e2e2e2

        &:last-child
          border-bottom: none

      .row
        font-size: 16px
        font-weight: 400
        font-family: 'Roboto', sans-serif
        color: #252525
        line-height: 1.1
        height: 60px
        align-items: center

        .active-marker
          margin-left: 10px
          border-radius: 5px
          padding: 6px 10px
          color: #fff
          background-color: #d00
          text-transform: uppercase
          font-weight: 700
          font-size: 13px

        .fal
          font-size: 22px
          color: #252525
          margin-right: 20px
          transition: all 300ms
          cursor: pointer

          &:hover
            opacity: 0.7

        .avatar
          width: 32px
          height: 32px
          border-radius: 50%
          overflow: hidden
          border: 1px solid rgba(#000, 0.1)
          background-size: cover

        .user-name
          margin-left: 15px

</style>
